import Row from '@components/Row';

import styles from './styles.module.scss';

interface Props {
    total: number;
    current: number;
    className?: string;
}

function Indicator({ total, current, className }:Props) {
  return (
        <Row className={className}
             spacing={12}
             aria-label='pagination' >
            {Array.from({ length: total }).map((_, i) => (
                <div className={`${styles.indicator} ${i === current ? styles.active : ''}`}
                     key={`indicator${i}`} />
            ))}
        </Row>
  );
}

export default Indicator;
